<div class="row mb-3" *ngIf="errorMsg !== ''">
  <div class="col-12">
    <div class="alert alert-danger p-2">
      <i class="fas fa-fw fa-exclamation-triangle me-2"></i>
      {{errorMsg}}
    </div>
  </div>
</div>
<div class="row my-2">
  <div class="col-12 col-md-4">
    <label class="my-1">First Name<span class="required">*</span>
    </label>
    <input type="text" [(ngModel)]="partyForm.f_name" value="" class="form-control form-control-sm" id="focusField" />
  </div>
  <div class="col-12 col-md-4">
    <label class="my-1">Last Name<span class="required">*</span></label>
    <input type="text" [(ngModel)]="partyForm.l_name" class="form-control form-control-sm" />
  </div>
  <div class="col-12 col-md-4">
    <label class="my-1">E-mail Address<span class="required">*</span></label>
    <input type="text" [(ngModel)]="partyForm.w_email" class="form-control form-control-sm" />
  </div>
</div>
<div class="row mb-2">
  <div class="col-12 col-md-4">
    <label class="my-1">Company Name<span class="required">*</span></label>
    <input type="text" [(ngModel)]="partyForm.company_name" class="form-control form-control-sm" />
  </div>
  <div class="col-12 col-md-4">
    <label class="my-1">Title<span class="required">*</span></label>
    <input type="text" [(ngModel)]="partyForm.title" class="form-control form-control-sm" />
  </div>
  <div class="col-12 col-md-4">
    <label class="my-1">LinkedIn Profile</label>
    <input type="text" [(ngModel)]="partyForm.linkedin_link" class="form-control form-control-sm" />
  </div>
</div>
<div class="row my-2">
  <div class="col-12 text-center">
    <button class="btn btn-sm btn-primary" (click)="addParty()">
      <i class="fas fa-fw fa-save me-2"></i>Save
    </button>
    

  </div>
</div>
